import React from 'react';
import '../styles/BeneficiaryForm.css';
import { useState, useEffect } from 'react';

const GenericForm = ({ kind = 'donor', initialData = {}, mode = 'add', onSubmit }) => {
    const isDonor = kind === 'donor';

    const [idType, setIdType] = useState(initialData.id_type || 'tz');
  
    useEffect(() => {
       
        if (initialData && Object.keys(initialData).length > 0) {
            
       
            const currentId = String(initialData.donor_id || initialData.id || '');
            
            
            if (/[A-Z]/i.test(currentId)) {
                setIdType('passport');
            } 
           
            else if (initialData.id_type) {
                setIdType(initialData.id_type);
            } 
           
            else {
                setIdType('tz');
            }
        }
    }, [initialData, initialData.donor_id, initialData.id]); 

    const handleSubmit = (e) => {
        e.preventDefault();
        const formData = new FormData(e.target);
        let data = Object.fromEntries(formData.entries());


        if (!data.donor_id && initialData.donor_id) {
            data.donor_id = initialData.donor_id;
        }



        if (isDonor) {
            data = {
                donor_id: data.donor_id,
                id_type: idType,
                first_name: data.first_name,
                last_name: data.last_name,
                address: data.address,
                email: data.email,
                phone: data.phone,
                status: data.status,
                comments: data.comments
            };
        }
        onSubmit(data);
    };

    const [comments, setComments] = useState(initialData.comments || '');
    useEffect(() => {
        setComments(initialData.comments || '');
    }, [initialData.comments]);

    return (
        <div className="form-container">
            <form onSubmit={handleSubmit} className="beneficiary-form">
                <div className="form-row" id='passport'>
                    <div className="form-group">
                        <label>
                            {idType === 'passport' ? 'מספר דרכון' : (isDonor ? 'ת.ז.' : 'תעודת זהות')}
                        </label>
                        <input
                            name={isDonor ? 'donor_id' : 'id'}
                            required
                            defaultValue={initialData[isDonor ? 'donor_id' : 'id'] || ''}
                            readOnly={mode === 'edit'}
                            className={mode === 'edit' ? 'read-only-field' : ''}
                        />
                        {/* שינוי הלייבל דינמית */}
                        <div style={{ display: 'flex', gap: '15px', marginTop: '5px' }}>
                            <label style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                <input
                                    type="radio"
                                    name="id_type"
                                    value="tz"
                                    checked={idType === 'tz'}
                                    onChange={() => setIdType('tz')}
                                    disabled={mode === 'edit'}
                                />
                                ת.ז.
                            </label>
                            <label style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                <input
                                    type="radio"
                                    name="id_type"
                                    value="passport"
                                    checked={idType === 'passport'}
                                    onChange={() => setIdType('passport')}
                                    disabled={mode === 'edit'}
                                />
                                דרכון
                            </label>
                        </div>
                    </div>

                    <div className="form-group">
                        <label>שם פרטי</label>
                        <input name="first_name" required defaultValue={initialData.first_name || ''} />
                    </div>
                    <div className="form-group">
                        <label>שם משפחה</label>
                        <input name="last_name" required defaultValue={initialData.last_name || ''} />
                    </div>
                </div>

                <div className="form-row" style={{ marginTop: '10px' }}>
                    <div className="form-group">
                        <label>כתובת</label>
                        <input name="address" defaultValue={initialData.address || ''} />
                    </div>
                    <div className="form-group">
                        <label>אימייל</label>
                        <input name="email" type="email" defaultValue={initialData.email || ''} />
                    </div>
                    <div className="form-group">
                        <label>פלאפון</label>
                        <input name="phone" defaultValue={initialData.phone || ''} />
                    </div>
                </div>

                {isDonor ? (
                    <div className="form-row">
                        <div className="form-group">
                            <label>סטטוס</label>
                            <select
                                name="status"
                                required
                                defaultValue={initialData.status || 'active'}
                                className="custom-select-status"
                            >
                                <option value="active">פעיל</option>
                                <option value="inactive">לא פעיל</option>
                                <option value="recurring">חוזר</option>
                            </select>
                        </div>
                    </div>

                ) : (
                    <>
                        <div className="form-row">
                            <div className="form-group">
                                <label>מורה מקשרת</label>
                                <input name="referring_teacher" defaultValue={initialData.referring_teacher || ''} />
                            </div>
                            <div className="form-group">
                                <label>פלא' מורה מקשרת</label>
                                <input name="teacher_phone" defaultValue={initialData.teacher_phone || ''} />
                            </div>
                            <div className="radio-column">
                                <div className="radio-header">דירוג מקרה</div>
                                {['קל', 'קשה'].map((caseOption, index) => (
                                    <label key={index}>
                                        <input
                                            type="radio"
                                            name="type_case"
                                            value={caseOption}
                                            defaultChecked={initialData.type_case === caseOption}
                                            required
                                        />
                                        <span style={{ color: 'gray' }}>{caseOption}</span>
                                    </label>
                                ))}
                            </div>
                        </div>


                    </>
                )}
                <div className="form-row">
                    <div className="form-group form-group-full">
                        <label>הערות</label>
                        {/* <textarea name="comments" defaultValue={initialData.comments || ''} /> */}
                        <textarea
                            name="comments"
                            value={comments}
                            onChange={(e) => setComments(e.target.value)}
                        />
                    </div>
                </div>

                <button type="submit" className="pink-btn">
                    {mode === 'edit' ? (
                        <>

                            <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2">
                                <path d="M12 20h9" />
                                <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5z" />
                            </svg>
                            עדכון פרטים
                        </>
                    ) : (
                        <>

                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#EF5DA8" strokeWidth="2">
                                <circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="16" /><line x1="8" y1="12" x2="16" y2="12" />
                            </svg>
                            הוספה
                        </>
                    )}
                </button>
            </form>
        </div>
    );
};

export default GenericForm;



